import type { ViewMode } from "../hooks/useViewMode";

interface Props {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  /** Accessible label for the control group */
  label?: string;
  /** Visible label on the tiles button */
  tilesLabel?: string;
  /** Visible label on the list button */
  listLabel?: string;
}

/** Switch between tile (grid) and list layout. */
export default function ViewModeToggle({
  value,
  onChange,
  label = "Weergave",
  tilesLabel = "Tegels",
  listLabel = "Lijst",
}: Props) {
  return (
    <div className="view-mode-toggle" role="group" aria-label={label}>
      <button
        type="button"
        className={value === "tiles" ? "active" : ""}
        onClick={() => onChange("tiles")}
        title={tilesLabel}
        aria-pressed={value === "tiles"}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
        </svg>
        <span className="view-mode-toggle-label">{tilesLabel}</span>
      </button>
      <button
        type="button"
        className={value === "list" ? "active" : ""}
        onClick={() => onChange("list")}
        title={listLabel}
        aria-pressed={value === "list"}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="8" y1="6" x2="21" y2="6" />
          <line x1="8" y1="12" x2="21" y2="12" />
          <line x1="8" y1="18" x2="21" y2="18" />
          <line x1="3" y1="6" x2="3.01" y2="6" />
          <line x1="3" y1="12" x2="3.01" y2="12" />
          <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
        <span className="view-mode-toggle-label">{listLabel}</span>
      </button>
    </div>
  );
}
